import React, {Fragment, PureComponent} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {Col, Row} from 'reactstrap';

import conf from '../../../conf.js';
import api from '../../../../api';

import './SkillFileStep.scss';
import FormTitleRow from "../../../../shared/components/Styled/Form/FormTitleRow.jsx";
import ParagraphLeftAlign from "../../../../shared/components/Styled/ParagraphLeftAlign.jsx";
import PrimaryButton from "../../../../shared/components/Styled/Buttons/PrimaryButton.jsx";
import {setCurrentUser} from "../../../components/CurrentUserLoader/actions.js";
import SecondaryButton from "../../../../shared/components/Styled/Buttons/SecondaryButton.jsx";
import {CREATE_FREELANCE_STEPS, updateCreatFreelanceStep} from "../../../../shared/containers/Freelance/setNextStep.js";

import ReScheduleModal from "./MeetingConfirmationStepModals/ReScheduleModal.jsx";
import DivBlueBg from "../../../../shared/components/Styled/Blocs/DivBlueBg.jsx";
import FreelanceAgent from "../../../components/Agent/FreelanceAgent.jsx";

import {toastr} from 'react-redux-toastr';
import AppointmentTookPlaceConfirmModal
  from "../../../../shared/components/Modals/RescheduleAppointment/AppointmentTookPlaceConfirmModal.jsx";
import TwineedsLinkedinLink from "../../../components/Linkedin/TwineedsLinkedinLink.jsx";
import ParagraphJustifyAlign from "../../../../shared/components/Styled/ParagraphJustifyAlign.jsx";
import VideosModal from '../../../../shared/components/Modals/VideosModal/VideosModal.jsx';
import { generate } from '../../../routes.js';
import { Link } from 'react-router-dom';

const calendlyJS = 'calendly-js';
const calendlyCSS = 'calendly-css';

class MeetingConfirmationStep extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    freelance: PropTypes.object.isRequired,
    submit: PropTypes.func.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      videosModal: true,
      isRescheduleModalOpen: false,
      isAppointmentTookPlaceModalOpen: false,
    };
  }

  componentDidMount = async () => {
    this.setupCalendly();
  }

  updateUserData = async() => {
    this.props.setCurrentUser((await api.users.getMe()).data);
  }

  componentWillUnmount() {
    this.removeCalendlyListener();
  }

  goToStep = (step) => {
    const {agent, ...freelanceData} = this.props.freelance
    updateCreatFreelanceStep(
      freelanceData.id,
      step,
      () => this.props.submit({
        freelance: {
          ...freelanceData
        },
        silentMode: true,
      })
    )
  }

  setupCalendly = () => {
    this.setState({loading: true});

    const head = document.getElementsByTagName('head')[0];

    const script = document.createElement("script");
    script.src = 'https://assets.calendly.com/assets/external/widget.js';
    script.id = calendlyJS;
    script.async = true;
    script.onload = () => this.setState({loading: false});

    const link = document.createElement('link');
    link.href = 'https://assets.calendly.com/assets/external/widget.css';
    link.id = calendlyCSS;
    link.rel = 'stylesheet';

    head.appendChild(script);
    head.appendChild(link);

    window.addEventListener('message', this.handleMessage);
  };

  removeCalendlyListener = () => {
    const head = document.getElementsByTagName('head')[0];

    head.removeChild(document.getElementById(calendlyJS));
    head.removeChild(document.getElementById(calendlyCSS));

    window.removeEventListener('message', this.handleMessage);
  };

  handleMessage = async (event) => {
    if (this.isCalendlyEvent(event)) {
      if (event.data.event === 'calendly.event_scheduled') {
        window.Calendly.closePopupWidget();
        toastr.success('Le rendez vous a correctement été replanifié');
        await this.updateUserData()
      }
      if (event.data.event === 'invitee.canceled') {
        toastr.success('Le rendez vous à été annulé');
      }
    }
  };

  isCalendlyEvent = (e) => {
    return e.data.event &&
      e.data.event.indexOf('calendly') === 0;
  };

  openCalendlyWidget = (e) => {
    const calendlyUrl = this.props.currentUniverse?.calendly_url ?? null;
    const shouldOpenCalendly = null !== calendlyUrl

    e.preventDefault();
    if (shouldOpenCalendly) {
      window.Calendly.initPopupWidget({
        url: calendlyUrl,
        prefill: {
          firstName: this.props.currentUser?.firstname ?? null,
          lastName: this.props.currentUser?.lastname ?? null,
          email: this.props.currentUser?.email ?? null,
          customAnswers: {
            a1: this.props.currentUser?.tel ?? null
          }
        }
      });
    }
  };
  cancelAppointment = async () => {
    const {currentUser} = this.props
    if(!currentUser || !currentUser.meeting || !currentUser.meeting.event_id) {
      console.warn('No meeting event id found')
      return
    }

    try {
      await api.calendly.cancel({
        eventUuid: this.props.currentUser.meeting.event_id
      }).then(() => {
        this.updateUserData()
        toastr.success('Le rendez vous à été annulé');
      })
    } catch (error) {
      if(error && error.data && !error.data.success && error.data.error){
        toastr.error( error.data.error)
      }
    }
  };

  handleAppointmentTookPlace = () => {
    const meetingTime = this.props.currentUser?.meeting?.start_time ?? null;
    if(!meetingTime) {
      this.appointmentTookPlaceSuccess()
      return
    }

    const now = new Date().getTime()
    const meetingTimeDate = new Date(meetingTime).getTime()
    if(now >= meetingTimeDate) {
      this.appointmentTookPlaceSuccess()
      return
    }

    this.setState({isAppointmentTookPlaceModalOpen: true})
  }

  appointmentTookPlaceSuccess = () => {
    this.goToStep(CREATE_FREELANCE_STEPS.PRESENTATION)
  }

  render() {
    const {currentUser, freelance} = this.props;

    const hasMeetingScheduled = currentUser?.hasMeetingScheduled ?? null;

    const content = <Fragment>
      <FormTitleRow className={'mb-4'} text={"Votre rendez vous en visio a été réservé"} chip={"1"}/>

      {freelance.agent && freelance.agent.id && (
        <Row>
          <Col xs={12}>
            <div className="mt-4">
              <FreelanceAgent agentId={freelance.agent.id}/>
            </div>
          </Col>
        </Row>)
      }

      <Row>
        <Col xs={12} className={"pt-1"}>
          <ParagraphJustifyAlign className={"text-justify"}>
            Merci d’avoir pris rendez-vous ! Une confirmation de votre créneau vous a été envoyée par e-mail. Nous sommes ravis de pouvoir prochainement échanger avec vous sur votre parcours et vos projets.
          </ParagraphJustifyAlign>
        </Col>
      </Row>

      <Row>
        <Col>
          <DivBlueBg className={"mt-0 mb-2 px-2 py-1"}>
            <ParagraphLeftAlign>
              <strong>
              Un empêchement ? Vous pouvez replanifier ou annuler notre rendez-vous !
              </strong>
            </ParagraphLeftAlign>
            <ParagraphLeftAlign> Attention, ce rendez-vous est primordial pour avoir accès à nos missions
            </ParagraphLeftAlign>
            <Row className={"justify-content-center mt-4"}>
              <Col className={"text-center my-0 mb-3  mb-md-0 mb-lg-3 mb-xl-0"}>
                <PrimaryButton className={"mx-auto"} onClick={this.openCalendlyWidget}> Replanifier le rendez-vous </PrimaryButton>
              </Col>
              <Col className={"text-center"}>
                {hasMeetingScheduled &&
                  <SecondaryButton onClick={this.cancelAppointment} className={"mx-auto"}> Annuler le rendez-vous  </SecondaryButton>
                }
              </Col>
            </Row>
          </DivBlueBg>
        </Col>
      </Row>

      <Row>
        <Col>
          <ParagraphLeftAlign>
            <strong>
              Ne perdez pas de temps !
            </strong>{' '}
            Suivez dès maintenant la page <TwineedsLinkedinLink text="Twineeds"/> sur Linkedin pour ne louper aucune mission et être au courant des dernières actualités !
          </ParagraphLeftAlign>
        </Col>
      </Row>

      <FormTitleRow className={'my-4'} text={"Vous avez manqué la vidéo ?"} chip={"2"}/>
      <Row>
        <Col>
          <div className="text-center mb-2">
            <Link className="btn btn-primary" to={generate({name: 'our-videos'})} target="_blank" rel="noopener noreferrer">
              Découvrir Twineeds en vidéo
            </Link>
          </div>
        </Col>
      </Row>

      <FormTitleRow className={"my-4"} text={"Votre rendez-vous en visio a été honoré ? "} chip={"3"}/>

      <Row className={"justify-content-center my-4"}>
        <Col className={"text-center my-0 mb-3 mb-md-0 mb-lg-3 mb-xl-0"}>
          <PrimaryButton onClick={this.handleAppointmentTookPlace} className={"mx-auto"}> Oui mon rendez-vous a eu lieu</PrimaryButton>
        </Col>
        <Col className={"text-center"}>
          <SecondaryButton className={"mx-auto"} onClick={() => this.setState({isRescheduleModalOpen: true})}> Non, il y a eu un problème </SecondaryButton>
        </Col>
      </Row>

      <ReScheduleModal
        isOpen={this.state.isRescheduleModalOpen}
        closeModal={() => this.setState({isRescheduleModalOpen: false})}
        backdrop={true}
        openCalendlyWidget={this.openCalendlyWidget}
      />
      <AppointmentTookPlaceConfirmModal
        isOpen={this.state.isAppointmentTookPlaceModalOpen}
        closeModal={() => this.setState({isAppointmentTookPlaceModalOpen: false})}
        backdrop={true}
        onAppointmentTookPlaceConfirm={this.appointmentTookPlaceSuccess}/>

      <VideosModal
        freelance={freelance}
        isOpen={this.state.videosModal}
        closeModal={() => this.setState({videosModal: false})}/>
    </Fragment>

    return <div className="skills-file-step">{content}</div>;
  }
}

export default connect(
  (state) => ({
    contact: state.universe?.currentUniverse.contact ?? conf.site.emails.contact,
    currentUniverse: state.universe?.currentUniverse ?? null,
  }),
  (dispatch) => ({
    setCurrentUser: (user) => dispatch(setCurrentUser(user)),
  })
)(MeetingConfirmationStep);
